import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { finalChoice } from '../data/content';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
export function FinalChoiceSection() {
  return <section aria-labelledby="final-title" className="bg-teal-tint py-12 md:py-20" data-id="element-55" data-mp="15dtuli49690y">
      <div className="mx-auto max-w-page px-5 md:px-8" data-id="element-56" data-mp="10gv191sey63t">
        <SectionHeading id="final-title" title={finalChoice.title} data-id="element-57" data-mp="cpplemmh3dti" />

        <div className="mx-auto mt-8 grid max-w-[900px] gap-3 md:mt-12 md:grid-cols-2 md:gap-4" data-id="element-58" data-mp="cs23czs8do6k">
          <div className="rounded-xl border border-teal-tintLine bg-white/60 p-5 md:p-7" data-id="element-59" data-mp="7sz9mbhpb4dw">
            <h3 className="font-display text-[17px] font-extrabold uppercase tracking-tight text-ink/55" data-id="element-60" data-mp="lryxhgxe3f90">{finalChoice.without.title}</h3>
            <ul className="mt-4 space-y-3" data-id="element-61" data-mp="1x5j7l0uro4xe">
              {finalChoice.without.items.map(item => <li key={item} className="flex gap-3 text-[16px] leading-snug text-ink/60" data-id="element-62" data-mp="1t4hdeyfpij2a">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-ink/40" strokeWidth={2.5} aria-hidden="true" data-id="element-63" data-mp="122toxex78bno" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-xl border-2 border-orange bg-teal p-5 md:p-7" data-id="element-64" data-mp="1b3hv5ngcp7q0">
            <h3 className="font-display text-[17px] font-extrabold uppercase tracking-tight text-gold" data-id="element-65" data-mp="1g2ckl88tpuj3">{finalChoice.with.title}</h3>
            <ul className="mt-4 space-y-3" data-id="element-66" data-mp="jcv7w9bfb87w">
              {finalChoice.with.items.map(item => <li key={item} className="flex gap-3 text-[16px] font-medium leading-snug text-white" data-id="element-67" data-mp="ncvz6ujmfdwd">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold text-teal-dark" data-id="element-68" data-mp="sbpaqhfckutw">
                    <CheckIcon className="h-3 w-3" strokeWidth={3} aria-hidden="true" data-id="element-69" data-mp="x4rww4hsp202" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 flex max-w-[460px] justify-center" data-id="element-70" data-mp="4ktb4y4ngvc3">
          <CtaButton microcopy={finalChoice.microcopy} align="center" data-id="element-71" data-mp="17wih85w8kqx2" />
        </div>
      </div>
    </section>;
}